export { BrandingProvider, BrandingContext } from "./BrandingProvider";
export { useBranding } from "./useBranding";
export { BrandWordmark } from "./BrandWordmark";
export { resolveBranding, sanitizeBrandingColors, DEFAULT_BRANDING, DEFAULT_APP_NAME } from "./defaults";
export type { B2BBrandingConfig, ResolvedBranding } from "./types";
